module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-06-9cf9756fea66a2737d0170c4dcee38b5.jpg";